export class PlayerInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get mediaPlayer() {
        return this.parent;
    }
    isChannelFree(channel) {
        return this.mediaPlayer.playerChannels.getChannel(channel).channelInfo.isChannelFree;
    }
    // do not rename, used by IntentStart isSingleStartConditionFulfilled
    isSilenceSince(seconds) {
        let secondsNumber = 0;
        if (typeof seconds === 'string') {
            if (seconds.includes('.')) {
                secondsNumber = parseFloat(seconds);
            }
            else {
                secondsNumber = parseInt(seconds);
            }
        }
        else {
            secondsNumber = seconds;
        }
        return this.silenceSinceSeconds >= secondsNumber;
    }
    get silenceSinceSeconds() {
        return this.mediaPlayer.channelVoice.channelInfo.silenceSinceSeconds;
    }
}
